var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('ComHeader'),_c('router-view'),_c('ComFooter'),_c('GlobalLoginModal'),_c('VipBuy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }